// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__CSLhp","title":"style_title__KyeGv"};